export default {
      id: "arrow-right-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = 124
// module chunks = 241 242 243